class NewsletterPopup {
  constructor(container) {
    this.container = container;
    this.overlay = container.querySelector('[data-newsletter-popup-overlay]');
    this.closeButton = container.querySelector('[data-newsletter-popup-close]');
    this.form = container.querySelector('form');
    this.successMessage = container.querySelector('.newsletter-form__message--success');
    this.delay = parseInt(container.dataset.delay || '0', 10) * 1000;
    this.dismissDays = parseInt(container.dataset.dismissDays || '30', 10);
    this.storageKey = `newsletterPopupDismissed:${window.location.hostname}`;

    this.bindEvents();
    this.init();
  }

  bindEvents() {
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.close());
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });
  }

  init() {
    if (window.Shopify && Shopify.designMode) {
      this.open();
      return;
    }

    if (this.successMessage) {
      this.open();
      this.setDismissed();
      return;
    }

    if (this.isDismissed()) {
      return;
    }

    window.setTimeout(() => this.open(), this.delay);
  }

  open() {
    this.container.classList.add('is-active');
    document.body.classList.add('newsletter-popup-open');
    const emailInput = this.container.querySelector('input[type="email"]');
    if (emailInput) {
      emailInput.focus();
    }
  }

  close() {
    this.container.classList.remove('is-active');
    document.body.classList.remove('newsletter-popup-open');
    this.setDismissed();
  }

  isOpen() {
    return this.container.classList.contains('is-active');
  }

  isDismissed() {
    try {
      const storedValue = window.localStorage.getItem(this.storageKey);
      if (!storedValue) {
        return false;
      }

      const dismissUntil = parseInt(storedValue, 10);
      if (Number.isNaN(dismissUntil)) {
        return false;
      }

      return dismissUntil > Date.now();
    } catch (error) {
      return false;
    }
  }

  setDismissed() {
    try {
      const days = Number.isNaN(this.dismissDays) ? 30 : this.dismissDays;
      const duration = days > 0 ? days * 24 * 60 * 60 * 1000 : 0;
      const dismissUntil = duration > 0 ? Date.now() + duration : Number.MAX_SAFE_INTEGER;
      window.localStorage.setItem(this.storageKey, String(dismissUntil));
    } catch (error) {
      // Ignore storage errors
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-newsletter-popup]').forEach((popup) => {
    new NewsletterPopup(popup);
  });
});
